/* eslint-disable react/prop-types */
import React, { useRef } from 'react'
import Grid from '@mui/material/Grid'
import { useOutletContext } from 'react-router-dom'
import OfferPageForm from '../../Forms/OfferPageForm'
import Footer from './Footer'

export function OfferSection() {
  const formRef = useRef()
  const { verificationListing } = useOutletContext()

  return (
    <div style={{ position: 'relative' }}>
      <Grid container direction="column">
        <Grid item><OfferPageForm innerRef={formRef} listing={verificationListing} isWizard={false} /></Grid>
        <Grid item><Footer label="Save" onSubmit={() => formRef.current.requestSubmit()} /></Grid>
      </Grid>
    </div>
  )
}

export default OfferSection
